import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiResponse, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { Admin } from "../../common.types";
import { requestProfile } from "./profile.request";

const useProfile = (
  options?: QueryOptions<ApiResponse<Admin>, ApiServiceError<ApiError>>
) => {
  const { data = {}, ...rest } = useQuery({
    queryKey: ["admin", "me"],
    queryFn: requestProfile,
    ...options
  });

  return { user: data, ...rest };
};

export default useProfile;
